var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservationlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "#F9F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 37C12.5889 37 12.0833 36.7833 11.65 36.35C11.2167 35.9167 11 35.4111 11 34.8333V13.1667C11 12.5889 11.2167 12.0833 11.65 11.65C12.0833 11.2167 12.5889 11 13.1667 11H34.8333C35.4111 11 35.9167 11.2167 36.35 11.65C36.7833 12.0833 37 12.5889 37 13.1667V34.8333C37 35.4111 36.7833 35.9167 36.35 36.35C35.9167 36.7833 35.4111 37 34.8333 37H13.1667ZM13.1667 34.8333H34.8333V13.1667H32.6667V22.7722L30.6083 20.75L28.55 22.7722V13.1667H13.1667V34.8333Z",
    fill: "#240b3b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5889 31.5111H16.7778V29.3444H25.5889V31.5111Z",
    fill: "#240b3b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5889 25.5889H16.7778V23.4222H25.5889V25.5889Z",
    fill: "#240b3b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5889 19.6667H16.7778V17.5H25.5889V19.6667Z",
    fill: "#240b3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationlist);
export default __webpack_public_path__ + "static/media/reservationlist.65ace5bbbdf856c1777657b243b2711f.svg";
export { ForwardRef as ReactComponent };